import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["customComment", "finalComment"];

  toggleComment(event) {
    const selected = event.target.value;

    if (selected === "Other") {
      this.customCommentTarget.style.display = "block";
      this.finalCommentTarget.value = "";
    } else {
      this.customCommentTarget.style.display = "none";
      this.finalCommentTarget.value = selected;
    }
  }

  connect() {
    const select = this.element.querySelector("select");
    const textarea = this.customCommentTarget.querySelector("textarea");

    if (textarea) {
      textarea.addEventListener("input", () => {
        this.finalCommentTarget.value = textarea.value;
      });
    }

    // Set initial value if dropdown was selected
    if (select.value !== "Other") {
      this.finalCommentTarget.value = select.value;
    }
  }
}